import React from 'react';
type PillVariant = 'solid' | 'outline' | 'ghost';
type PillSize = 'sm' | 'md';
interface PillButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: PillVariant;
  size?: PillSize;
  className?: string;
  ariaPressed?: boolean;
}
const VARIANTS: Record<PillVariant, string> = {
  solid: 'bg-solventum-primary text-solventum-bg border border-solventum-primary hover:bg-solventum-primary/90',
  outline: 'border border-white/20 text-white hover:border-solventum-primary hover:text-solventum-primary',
  ghost: 'border border-transparent text-white/50 hover:text-solventum-primary'
};
const SIZES: Record<PillSize, string> = {
  sm: 'px-3.5 py-1.5 text-[11px] tracking-[0.06em]',
  md: 'px-5 py-2.5 text-[13px] tracking-[0.04em]'
};

/** The only button shape in the experience: small, quiet, pill-shaped. */
export function PillButton({
  children,
  onClick,
  variant = 'outline',
  size = 'sm',
  className = '',
  ariaPressed
}: PillButtonProps) {
  return <button onClick={onClick} aria-pressed={ariaPressed} className={`inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full font-headline font-bold transition-[color,border-color,background-color,transform] duration-200 ease-out active:scale-[0.97] ${VARIANTS[variant]} ${SIZES[size]} ${className}`} data-id="element-93" data-mp="3rv3fxfmpbo0c">
      {children}
    </button>;
}